module.exports = __webpack_public_path__ + "static/media/carshowz_search.22c98389.png";